import { doMutation } from "../../core-module/util/graphqlHelper";

export const createOrUpdateSubscriberProfile = input => {
  const mutation = require("../api/mutation/createOrUpdateSubscriberProfile.gql");
  const variables = { input };

  return doMutation({ mutation, variables }).then(({ data, error }) => {
    if (data) return { data: data.createOrUpdateSubscriberProfile };
    else if (error) return { error: JSON.stringify(error) };
  });
};
